import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-coffee text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a
              href="#inicio"
              onClick={(e) => handleNavClick(e, '#inicio')}
              className="flex items-center mb-6"
              data-testid="footer-logo"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_salkantay-peru/artifacts/bq00gpv5_Disen%CC%83o%20sin%20ti%CC%81tulo-29.png"
                alt="SALKANTAY Logo"
                className="h-16 w-auto"
              />
            </a>
            <p className="text-white/70 text-sm leading-relaxed">
              La auténtica gastronomía peruana en Madrid. Calidad, sabor y tradición en cada bocado.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Navegación</h3>
            <ul className="space-y-3">
              {[
                { href: '#inicio', label: 'Inicio' },
                { href: '#nosotros', label: 'Sobre Nosotros' },
                { href: '#carta', label: 'Nuestra Carta' },
                { href: '#testimonios', label: 'Opiniones' },
                { href: '#ubicacion', label: 'Ubicación' },
                { href: '#contacto', label: 'Contacto' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-white/70 hover:text-gold transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                <span className="text-white/70 text-sm">
                  Calle Sierra Contraviesa 1,<br />
                  Entrevías, 28053 Madrid
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-gold flex-shrink-0" />
                <a
                  href="tel:+34623513773"
                  className="text-white/70 hover:text-white transition-colors text-sm"
                >
                  +34 623 51 37 73
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-gold flex-shrink-0" />
                <a
                  href="mailto:salkantayrestaurante@gmail.com"
                  className="text-white/70 hover:text-white transition-colors text-sm break-all"
                >
                  salkantayrestaurante@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Horario</h3>
            <div className="flex items-start gap-3">
              <Clock className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
              <div className="text-white/70 text-sm space-y-2">
                <p>
                  <span className="text-white font-medium">Lun-Dom:</span> 9:00 - 23:00
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex justify-center items-center">
          <p className="text-white/50 text-sm">
            © {currentYear} SALKANTAY Restaurante Peruano. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
